import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/RoleWarehouseDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class RoleWarehouseEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleWarehouse"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleWarehouse/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleWarehouse/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleWarehouse/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleWarehouse/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleWarehouse/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/roleWarehouse/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class RoleWarehouseFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedById: IFieldOptions = { field: "changedById" };
	public roleId: IFieldOptions = { field: "roleId" };
	public warehouseId: IFieldOptions = { field: "warehouseId" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.roleId);
		this.push(this.warehouseId);
	}
}

export class RoleWarehouseForm implements IFormOptions {
	protected roleWarehouseFormName: string = "roleWarehouseForm";
	protected roleWarehouseFormModel: models.RoleWarehouseDTO = new models.RoleWarehouseDTO();
	protected roleWarehouseFormEndPoints: RoleWarehouseEndPoints = new RoleWarehouseEndPoints();
	protected roleWarehouseFormFields: RoleWarehouseFormFields = new RoleWarehouseFormFields();
	public get name(): string { return this.roleWarehouseFormName };
	public get model(): models.RoleWarehouseDTO { return this.roleWarehouseFormModel };
	public get endPoints(): IEntityEndPoints { return this.roleWarehouseFormEndPoints };
       public set endPoints(roleWarehouseEndPoints: IEntityEndPoints) {
		this.roleWarehouseFormEndPoints = roleWarehouseEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): RoleWarehouseFormFields { return this.roleWarehouseFormFields };
}

export class RoleWarehouseListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedById: IColumnOptions = { field: "changedById" };
	public roleId: IColumnOptions = { field: "roleId" };
	public warehouseId: IColumnOptions = { field: "warehouseId" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.roleId);
		this.push(this.warehouseId);
	}
}

export class RoleWarehouseList implements IGridOptions {
	protected roleWarehouseListName: string = "roleWarehouseList";
	protected roleWarehouseListModel: models.RoleWarehouseDTO = new models.RoleWarehouseDTO();
	protected roleWarehouseListEndPoints: RoleWarehouseEndPoints = new RoleWarehouseEndPoints();
	protected roleWarehouseListColumns: RoleWarehouseListColumns = new RoleWarehouseListColumns();
	public roleWarehouseForm: RoleWarehouseForm = new RoleWarehouseForm();
	public get name(): string { return this.roleWarehouseListName };
	public get model(): models.RoleWarehouseDTO { return this.roleWarehouseListModel };
	public get endPoints(): IEntityEndPoints { return this.roleWarehouseListEndPoints };
	public set endPoints(roleWarehouseEndPoints: IEntityEndPoints) {
		this.roleWarehouseListEndPoints = roleWarehouseEndPoints;
		this.roleWarehouseForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): RoleWarehouseListColumns { return this.roleWarehouseListColumns };
}

export class RoleWarehouseEntity implements IEntityOptions {
	protected roleWarehouseEntityName: string = "roleWarehouseEntity";
	protected roleWarehouseEntityModel: models.RoleWarehouseDTO = new models.RoleWarehouseDTO();
	protected roleWarehouseEntityEndPoints: RoleWarehouseEndPoints = new RoleWarehouseEndPoints();
	protected roleWarehouseEntityList: RoleWarehouseList = new RoleWarehouseList();
	public get name(): string { return this.roleWarehouseEntityName };
	public get model(): models.RoleWarehouseDTO { return this.roleWarehouseEntityModel };
	public get endPoints(): IEntityEndPoints { return this.roleWarehouseEntityEndPoints };
	public set endPoints(roleWarehouseEndPoints: IEntityEndPoints) {
		this.roleWarehouseEntityEndPoints = roleWarehouseEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): RoleWarehouseList { return this.roleWarehouseEntityList };
	public get form(): RoleWarehouseForm { return this.grid.roleWarehouseForm };
	constructor(name?: string) {
		if (name) this.roleWarehouseEntityName = name;
		this.endPoints = this.roleWarehouseEntityEndPoints;
	}
};
//export class RoleWarehouseGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: RoleWarehouseForm = new RoleWarehouseForm();
//};

//export class RoleWarehouseListPageComponent extends ListPageComponent {
  //protected listPageComponentList: RoleWarehouseList = new  RoleWarehouseList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class RoleWarehouseBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RoleWarehouseGeneratedForm}];
//};

//export class RoleWarehouseListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RoleWarehouseListPageComponent, isMenuHidden: true }];
//};

